import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "pIndexListItem",
  props: {
    detail: null,
    isEmpty: {
      default: false,
      typeof: Boolean
    }
  },
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  data() {
    return {
      nowTime: parseInt(new Date().getTime() / 1000)
    };
  },
  mouted() {}
};